import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Intersection } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/isMouseIntersectInterval';
import { formatHourDecimalToTimeString } from '@/domain/dienstplan/features/VisualEditor/utils/timeHelper/formatHourDecimalToTimeString';
import {
  Belegung,
  BelegungsIntervall,
} from '@/domain/dienstplan/shared/types/Belegung';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { mapWochentagForAPI } from '@/domain/dienstplan/shared/utils/mapWochentagForAPI';
import { toast } from '@/hooks/use-toast';

export function endBelegungCreate({
  ctx,
  collision,
}: {
  ctx: SharedContext;
  collision?: Intersection;
}) {
  const { belegungen } = ctx;
  const activeBelegungIntervall = belegungen.find((b) => b.mode === 'active');
  if (!activeBelegungIntervall) return;
  if (collision === undefined || collision.isIntersect === false) {
    const inactiveInterval = new BelegungsIntervall(
      activeBelegungIntervall.belegung,
      'inactive',
    );
    updateBelegungen(inactiveInterval, activeBelegungIntervall, ctx);
    return;
  }

  const updatedActiveBelegung = new BelegungsIntervall(
    new Belegung({
      ...activeBelegungIntervall.belegung,
      start:
        collision.collision.direction === 'west'
          ? collision.collision.interfall.belegung.ende
          : activeBelegungIntervall.belegung.start,
      ende:
        collision.collision.direction === 'east'
          ? collision.collision.interfall.belegung.start
          : activeBelegungIntervall.belegung.ende,
    }),
    activeBelegungIntervall.mode,
  );
  const inactiveInterval = new BelegungsIntervall(
    updatedActiveBelegung.belegung,
    'inactive',
  );

  updateBelegungen(inactiveInterval, updatedActiveBelegung, ctx);
}
function updateBelegungen(
  inactiveInterval: BelegungsIntervall,
  activeBelegung: BelegungsIntervall,
  ctx: SharedContext,
) {
  const {
    store: {
      removeBelegungById,
      setStartBelegungPosition,
      updateBelegungById,
      setIsCreatingNewBelegung,
    },
  } = ctx;
  updateBelegungById(inactiveInterval, inactiveInterval.belegung.id);
  setStartBelegungPosition(undefined);
  setIsCreatingNewBelegung(false);

  if (
    activeBelegung.belegung.start === activeBelegung.belegung.ende ||
    activeBelegung.belegung.personenanzahlMax <= 0
  ) {
    removeBelegungById(activeBelegung.belegung.id);
  } else {
    ctx
      .createBelegung({
        input: {
          anzahlMitarbeiter: activeBelegung.belegung.personenanzahlMax,
          arbeitsbereichId: activeBelegung.belegung.arbeitsbereich.id,
          tag: mapWochentagForAPI(ctx.weekday as Weekday),
          dauer: Math.floor(activeBelegung.width * 60),
          von: formatHourDecimalToTimeString(activeBelegung.belegung.start, 0),
          managerId: ctx.manager.id,
        },
      })
      .then((result) => {
        const newBelegungInterval = new BelegungsIntervall(
          new Belegung({
            ...activeBelegung.belegung,
            id: result.data.dienstplan_createBelegungen.id,
          }),
          'inactive',
        );

        updateBelegungById(newBelegungInterval, activeBelegung.belegung.id);

        toast({
          title: ctx.t(
            'domain.dienstplan.mindestbelegung.visualEditor.createSuccess',
          ),
        });
      });
  }
}
